import React, { useState } from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";

export default function TOC({ data }) {
  const [showAccordion, setShowAccordion] = useState(false);

  return (
    <div className="my-6">
      <div className="flex flex-row items-center justify-between bg-[#f7f7f7] px-3 py-2">
        <h2 className="font-[lato] uppercase font-light text-sm md:text-base">
          Table of Contents
        </h2>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={`size-6 xl:size-8 text-bhagwa cursor-pointer ${
            !showAccordion ? "" : "rotate-180"
          }`}
          onClick={() => setShowAccordion(!showAccordion)}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m19.5 8.25-7.5 7.5-7.5-7.5"
          />
        </svg>
      </div>
      {showAccordion && (
        <div className="bg-[#f7f7f7] px-3 py-2 max-w-none prose prose-a:hover:cursor-pointer prose-a:font-[optima-lt-pro] prose-a:no-underline text-black prose-ol:font-[optima-lt-pro] prose-li:font-[optima-lt-pro] prose-li:text-sm  md:prose-li:text-base">
          <Markdown rehypePlugins={[rehypeRaw]}>{data}</Markdown>
        </div>
      )}
    </div>
  );
}
